<section>
    <h1 id="headline-skill">{{ 'SKILLSET' | translate }}</h1>
    <div>
        <div class="imageFrame" *ngFor="let img of skillSet; let i = index">
            <img src="./assets/img/skill-section/{{ img }}.png">
            <p >{{ img }}</p>
        </div>
    </div>
</section>
